// Shared helpers for extracting Term Journey identifiers from API responses

/**
 * Safely normalizes the response into an object.
 * Supports both already-parsed objects and raw JSON strings.
 */
const normalizeResponse = (response) => {
  if (!response) {
    return null;
  }

  if (typeof response === 'string') {
    try {
      return JSON.parse(response);
    } catch {
      return null;
    }
  }

  if (typeof response === 'object') {
    return response;
  }

  return null;
};

/**
 * Extract applicationNumber from various possible backend response shapes.
 *
 * Supported shapes include:
 * - { applicationNumber }
 * - { r_applicationNumber_c_applicationNumber }
 * - { applicationNumber_c_applicationNumber }
 * - { items: [{ applicationNumber | r_applicationNumber_c_applicationNumber }] }
 */
export const extractApplicationNumberFromResponse = (response) => {
  const data = normalizeResponse(response);
  if (!data) {
    return null;
  }

  const possibleFields = [
    data.applicationNumber,
    data.r_applicationNumber_c_applicationNumber,
    data.applicationNumber_c_applicationNumber,
    data.items?.[0]?.applicationNumber,
    data.items?.[0]?.r_applicationNumber_c_applicationNumber,
  ];

  const value = possibleFields.find(
    (val) => val != null && val !== '' && val !== 'null'
  );

  return value || null;
};

/**
 * Extract caseId from various possible backend response shapes.
 *
 * Supported shapes include:
 * - { caseId }
 * - { r_caseId_c_caseId }
 * - { caseId_c_caseId }
 * - { items: [{ caseId | r_caseId_c_caseId }] }
 */
export const extractCaseIdFromResponse = (response) => {
  const data = normalizeResponse(response);
  if (!data) {
    return null;
  }

  const possibleFields = [
    data.caseId,
    data.r_caseId_c_caseId,
    data.caseId_c_caseId,
    data.items?.[0]?.caseId,
    data.items?.[0]?.r_caseId_c_caseId,
  ];

  const value = possibleFields.find(
    (val) => val != null && val !== '' && val !== 'null'
  );

  return value || null;
};

